/* Модуль совместимости оплат и модалок (заглушки для исключения ошибок вызова) */
function openAllDaysCheckout() { return false; }
function openPayModal() { return false; }
function closePayModal() { return false; }
function openExternalPaymentUrl() { return false; }
function simulatePaymentSuccess() { return false; }
function onPaymentInitiated() { return false; }
function openBonusModal() { return false; }
function closeBonusModal() { return false; }
function openQuestionnaireModal() { window.location.href = '/questionnaire.html'; return true; }
function closeQuestionnaireModal() { return false; }
function handleQuestionnaireSubmit() { return false; }
function addTestBonuses() { return false; }
function unlockDayWithBonus() { return false; }
function updateDashboardDayCards() { if (typeof updateDashboardDaysUI === 'function') updateDashboardDaysUI(); return false; }
function openDay2Modal() { return false; }
function openDay3Modal() { return false; }
function openDay4Modal() { return false; }